module.exports = __webpack_public_path__ + "static/media/close-eye.c15aa3e2.svg";